export interface JwtPayload {
  sub?: string;
  email?: string;
  businessId?: string;
  userId?: string;
  firstName?: string;
  lastName?: string;
  roles?: string[];
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

/**
 * Decodes a JWT payload without verifying the signature.
 * Client-side only — the backend validates tokens via JwtAuthFilter.
 */
export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);
    return JSON.parse(atob(base64)) as JwtPayload;
  } catch {
    console.error("Failed to decode JWT");
    return null;
  }
}

export function isTokenExpired(payload: JwtPayload | null): boolean {
  if (!payload || !payload.exp) return true;
  return payload.exp * 1000 < Date.now();
}
